import PropTypes from 'prop-types';
import { Grid, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider, Stack } from '@mui/material';
export const OrderInvoice = ({ order }) => {
    if (!order) return null;

    return (
        <Box sx={{ p: 4, bgcolor: 'white', color: 'black', minHeight: '297mm' }}>
            {/* Business Header */}
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={4}>
                <Box>
                    <Typography variant="h4" fontWeight={800} color="primary">
                        INVOICE
                    </Typography>
                    <Typography variant="body1">Order #{order.code}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Date: {new Date(order.createdAt).toLocaleDateString()}
                    </Typography>
                </Box>
                <Box textAlign="right">
                    <Typography variant="h6" fontWeight={700}>
                        {order.vendor?.name}
                    </Typography>
                    <Typography variant="body2" sx={{ maxWidth: 250 }}>
                        {order.vendor?.address}
                    </Typography>
                </Box>
            </Stack>

            <Divider sx={{ mb: 4 }} />

            {/* Customer & Shipping */}
            <Grid container spacing={4} sx={{ mb: 4 }}>
                <Grid item xs={6}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        BILL TO:
                    </Typography>
                    <Typography variant="body1" fontWeight={700}>
                        {order.user?.firstName} {order.user?.lastName}
                    </Typography>
                    <Typography variant="body2">{order.user?.phoneNumber}</Typography>
                    <Typography variant="body2">{order.user?.email}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        SHIP TO:
                    </Typography>
                    <Typography variant="body2">{order.deliveryAddress || order.destination?.street}</Typography>
                </Grid>
            </Grid>

            {/* Items Table */}
            <TableContainer>
                <Table sx={{ minWidth: 650 }}>
                    <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                        <TableRow>
                            <TableCell>
                                <Typography fontWeight={700}>Item Description</Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography fontWeight={700}>Qty</Typography>
                            </TableCell>
                            <TableCell align="right">
                                <Typography fontWeight={700}>Unit Price</Typography>
                            </TableCell>
                            <TableCell align="right">
                                <Typography fontWeight={700}>Amount</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {order.products?.map((item) => (
                            <TableRow key={item._id}>
                                <TableCell>{item.name}</TableCell>
                                <TableCell align="center">{item.quantity}</TableCell>
                                <TableCell align="right">₦{item.price.toLocaleString()}</TableCell>
                                <TableCell align="right">₦{(item.price * item.quantity).toLocaleString()}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Calculations */}
            <Box sx={{ mt: 4, width: '300px', ml: 'auto' }}>
                <Stack spacing={1}>
                    <Stack direction="row" justifyContent="space-between">
                        <Typography>Subtotal:</Typography>
                        <Typography>₦{order.amount.toLocaleString()}</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                        <Typography>Delivery Fee:</Typography>
                        <Typography>₦{order.deliveryFee.toLocaleString()}</Typography>
                    </Stack>
                    <Divider />
                    <Stack direction="row" justifyContent="space-between">
                        <Typography variant="h6" fontWeight={800}>
                            Total:
                        </Typography>
                        <Typography variant="h6" fontWeight={800}>
                            ₦{(order.amount + order.deliveryFee).toLocaleString()}
                        </Typography>
                    </Stack>
                </Stack>
            </Box>

            <Box sx={{ mt: 10, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    Thank you for your business!
                </Typography>
            </Box>
        </Box>
    );
};

OrderInvoice.propTypes = {
    order: PropTypes.shape({
        code: PropTypes.string,
        createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
        vendor: PropTypes.shape({
            name: PropTypes.string,
            address: PropTypes.string
        }),
        user: PropTypes.shape({
            firstName: PropTypes.string,
            lastName: PropTypes.string,
            phoneNumber: PropTypes.string,
            email: PropTypes.string
        }),
        deliveryAddress: PropTypes.string,
        destination: PropTypes.shape({
            street: PropTypes.string
        }),
        products: PropTypes.arrayOf(
            PropTypes.shape({
                _id: PropTypes.string,
                name: PropTypes.string,
                quantity: PropTypes.number,
                price: PropTypes.number
            })
        ),
        amount: PropTypes.number,
        deliveryFee: PropTypes.number
    })
};
